import CLoginForm from 'components/login-form/Index'
import CCodeInput from 'components/code-input/Index'
import CAppbar from 'components/appbar/Index'
import CEmptyPage from 'components/empty-page/Index'
import CGoBack from 'components/go-back/Index'
import CStars from 'components/stars/Index'
import CCreateComment from 'components/create-comment/Index'
import CUserEdit from 'components/user-edit/Index'
import CProductGrade from 'components/product-grade/Index'
import CPayMessage from 'components/pay-message/Index'
import CModalMessage from 'components/modal-message/ModalMessage'
import CMyCalendar from 'components/my-calendar/Index'

export default {
  CLoginForm,
  CCodeInput,
  CAppbar,
  CEmptyPage,
  CGoBack,
  CStars,
  CCreateComment,
  CUserEdit,
  CProductGrade,
  CPayMessage,
  CModalMessage,
  CMyCalendar,
}
